import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SystemSetup  {
    _originalTypeClassName = "zERP.BO.SystemSetup";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SystemSetup.translate = translateService;
}
this.SystemSetupKey = null;
this._key = this.SystemSetupKey = 0; 
}

static translate: TranslateService;
_key: any;
private _SystemSetupKey:any;
get SystemSetupKey(): any {
    return this._SystemSetupKey;
  }
set SystemSetupKey(value: any) {
    this._SystemSetupKey = value;
    this._key = value;
  }

static GetDocumentTypeName(documentType: any): any{if (documentType == "AadeBookInvoiceType") {return "Τιμολόγιο";}else if (documentType == "Payment") {return "Πληρωμή";}else if (documentType == "PaymentOrder") {return "Ένταλμα Πληρωμής";}else if (documentType == "Payroll") {return "Μισθοδοσία";}else if (documentType == "MoneyTransaction") {return "Χρηματική Κίνηση";}else if (documentType == "IncomeReceipt") {return "Είσπραξη";}else {return documentType;}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SystemSetupKey == null || $this.SystemSetupKey == 0;
            }


}